var React = require('react');

function DesktopInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.7493 0.833252H3.24935C1.69102 0.833252 0.416016 2.10825 0.416016 3.66659V20.6666C0.416016 22.2249 1.69102 23.4999 3.24935 23.4999H13.166V26.3333H10.3327V29.1666H21.666V26.3333H18.8327V23.4999H28.7493C30.3077 23.4999 31.5827 22.2249 31.5827 20.6666V3.66659C31.5827 2.10825 30.3077 0.833252 28.7493 0.833252ZM28.7493 20.6666H3.24935V3.66659H28.7493V20.6666Z","fill":"#546E7A"}));
}

DesktopInline.defaultProps = {"width":"32","height":"30","viewBox":"0 0 32 30","fill":"none"};

module.exports = DesktopInline;

DesktopInline.default = DesktopInline;
